module.exports = __webpack_public_path__ + "static/media/hero-clouds-reverse@2x.ac8460b7.jpg";